import { render, staticRenderFns } from "./DialogModalLayout.vue?vue&type=template&id=50c42bc3"
import script from "./DialogModalLayout.vue?vue&type=script&lang=ts"
export * from "./DialogModalLayout.vue?vue&type=script&lang=ts"
import style0 from "./DialogModalLayout.vue?vue&type=style&index=0&id=50c42bc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports